import { ChartType } from '@ge/components/charts';
import { KpiCategoryDefs } from '@ge/models/constants';

import { FilterDefs } from './analyze-filter-defaults';
import { KpiCategoryDataType, KpiCategorySeriesType } from './constants';

const AvailabilityDefs = {
  contractual_availability: {
    graph4: {
      default: {
        categories: [
          {
            grouping: FilterDefs.AVAILABILITY,
            key: KpiCategoryDefs.AVAILABILITY_CONTRACT,
            type: KpiCategoryDataType.PERCENT,
          },
        ],
        seriesType: KpiCategorySeriesType.TIME_SERIES,
        type: ChartType.SPLINE,
      },
      // TODO: review if it's naive to assume a single sort across both default and alternate charts
      sortEntitiesBy: KpiCategoryDefs.AVAILABILITY_CONTRACT,
    },
  },
  pba: {
    graph4: {
      default: {
        categories: [
          {
            grouping: FilterDefs.AVAILABILITY,
            key: KpiCategoryDefs.PBA,
            type: KpiCategoryDataType.PERCENT,
          },
        ],
        seriesType: KpiCategorySeriesType.TIME_SERIES,
        type: ChartType.SPLINE,
      },
      sortEntitiesBy: KpiCategoryDefs.PBA,
    },
  },
  tba: {
    graph4: {
      default: {
        categories: [
          {
            grouping: FilterDefs.AVAILABILITY,
            key: KpiCategoryDefs.TBA,
            type: KpiCategoryDataType.PERCENT,
          },
        ],
        seriesType: KpiCategorySeriesType.TIME_SERIES,
        type: ChartType.SPLINE,
      },
      sortEntitiesBy: KpiCategoryDefs.TBA,
    },
  },
};

const DataQualityDefs = {
  event_coverage: {
    graph4: {
      default: {
        categories: [
          {
            grouping: FilterDefs.DATA_QUALITY,
            key: KpiCategoryDefs.EVENT_COVERAGE,
            type: KpiCategoryDataType.PERCENT,
          },
        ],
        seriesType: KpiCategorySeriesType.TIME_SERIES,
        type: ChartType.COLUMN,
      },
      sortEntitiesBy: KpiCategoryDefs.EVENT_COVERAGE,
    },
  },
  reporting_turbine_ratio: {
    graph4: {
      default: {
        categories: [
          {
            grouping: FilterDefs.DATA_QUALITY,
            key: KpiCategoryDefs.REPORTING_ASSETS_RATIO,
            type: KpiCategoryDataType.NONE,
          },
        ],
        seriesType: KpiCategorySeriesType.TIME_SERIES,
        type: ChartType.COLUMN,
      },
    },
  },
};

const PerformanceDefs = {
  actual_production: {
    graph4: {
      default: {
        categories: [
          {
            grouping: FilterDefs.PERFORMANCE,
            key: KpiCategoryDefs.PRODUCTION_ACTUAL,
            type: KpiCategoryDataType.ENERGY,
          },
        ],
        seriesType: KpiCategorySeriesType.TIME_SERIES,
        type: ChartType.COLUMN,
      },
      sortEntitiesBy: KpiCategoryDefs.PRODUCTION_ACTUAL,
    },
  },
  actual_vs_expected_production: {
    // remmoving for MVP until contract/learned filter is added back in
    // contract_curve: {
    graph4: {
      default: {
        categories: [
          {
            grouping: FilterDefs.PERFORMANCE,
            key: KpiCategoryDefs.PRODUCTION_ACTUAL,
            type: KpiCategoryDataType.ENERGY,
          },
          {
            grouping: FilterDefs.PERFORMANCE,
            key: KpiCategoryDefs.PRODUCTION_EXPECTED_CONTRACT,
            type: KpiCategoryDataType.ENERGY,
          },
        ],
        seriesType: KpiCategorySeriesType.TIME_SERIES,
        type: ChartType.COLUMN,
      },
    },
    // },
  },
  capacity_factor: {
    graph4: {
      default: {
        categories: [
          {
            grouping: FilterDefs.PERFORMANCE,
            key: KpiCategoryDefs.CAPACITY_FACTOR,
            type: KpiCategoryDataType.PERCENT,
          },
        ],
        seriesType: KpiCategorySeriesType.TIME_SERIES,
        type: ChartType.SPLINE,
      },
      sortEntitiesBy: KpiCategoryDefs.CAPACITY_FACTOR,
    },
  },
  expected_production: {
    // remmoving for MVP until contract/learned filter is added back in
    // contract_curve: {
    graph4: {
      default: {
        categories: [
          {
            grouping: FilterDefs.PERFORMANCE,
            key: KpiCategoryDefs.PRODUCTION_EXPECTED_CONTRACT,
            type: KpiCategoryDataType.ENERGY,
          },
        ],
        seriesType: KpiCategorySeriesType.TIME_SERIES,
        type: ChartType.COLUMN,
      },
      sortEntitiesBy: KpiCategoryDefs.PRODUCTION_EXPECTED_CONTRACT,
    },
    // },
  },
  lost_production: {
    // remmoving for MVP until contract/learned filter is added back in
    // contract_curve: {
    graph4: {
      default: {
        categories: [
          {
            grouping: FilterDefs.PERFORMANCE,
            key: KpiCategoryDefs.PRODUCTION_LOST_CONTRACT,
            type: KpiCategoryDataType.ENERGY,
          },
        ],
        seriesType: KpiCategorySeriesType.TIME_SERIES,
        type: ChartType.COLUMN,
      },
      sortEntitiesBy: KpiCategoryDefs.PRODUCTION_LOST_CONTRACT,
    },
    // },
  },
};

// model representation of the ge spreadsheet for what goes in what graph
// maps between filter bar and kpi data fetch defs
export const AssetKpiChartDefs = {
  [FilterDefs.AVAILABILITY]: AvailabilityDefs,
  [FilterDefs.DATA_QUALITY]: DataQualityDefs,
  [FilterDefs.PERFORMANCE]: PerformanceDefs,
};
